var InputModeEnum;
(function (InputModeEnum) {
    // Keyboard for letters and numbers - no special characters.
    InputModeEnum["text"] = "text";
    // Keypad for number inputs with decimals.
    InputModeEnum["decimal"] = "decimal";
    // Keypad for number inputs without decimals.
    InputModeEnum["numeric"] = "numeric";
    // Keypad for phone number inputs, including plus sign.
    InputModeEnum["tel"] = "tel";
    // Keyboard for search inputs - same keyboard layout as text.
    InputModeEnum["search"] = "search";
    // Keyboard for email inputs, including at sign, period, underscore, and dash.
    InputModeEnum["email"] = "email";
    // Keyboard for URL inputs - same keyboard layout as text.
    InputModeEnum["url"] = "url";
    // Keyboard for measurement inputs, including prime symbols, slash, and decimals.
    InputModeEnum["measurement"] = "measurement";
})(InputModeEnum || (InputModeEnum = {}));
export default InputModeEnum;
//# sourceMappingURL=InputModeEnum.js.map